export function publish<T>(name: string, data: T) {
    const event: Event = new CustomEvent(name, {
        detail: data
    });
    document.dispatchEvent(event);
}

export function subscribe<T>(name: string, callback: (data: T) => void) {
    document.addEventListener(name, (ev) => {
        callback((ev as any).detail);
    })
}
